// https://stackoverflow.com/a/50457849
export default function getEventFrame(e: MessageEvent): HTMLIFrameElement | undefined {
    const iframes = Array.from(document.getElementsByTagName('iframe'));

    return iframes.find((iframe) => iframe.contentWindow === e.source);
}
